/* frontend/src/components/ArticleCard.js */
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../pages/Blog.css';

const ArticleCard = ({ article }) => {
  return (
    <motion.div
      className="card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.03, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}
    >
      {article.thumbnail && (
        <img
          src={article.thumbnail}
          alt={article.title}
          className="w-full h-48 object-cover rounded-t-lg"
        />
      )}
      <div className="p-6">
        <h3 className="text-xl font-semibold">
          <Link to={`/blog/${article.id}`} className="hover:text-[#0a66c2]">
            {article.title}
          </Link>
        </h3>
        <p className="text-[#666666] text-sm mb-2">
          By {article.author_username} • {new Date(article.created_at).toLocaleDateString()}
        </p>
        <p className="text-[#333333] mb-4">{article.excerpt}</p>
        <div className="flex gap-4 text-sm text-[#666666]">
          <span>{article.view_count} views</span>
          <span>{article.likes_count} likes</span>
          <span>{article.shares_count} shares</span>
        </div>
      </div>
    </motion.div>
  );
};

export default ArticleCard;
